module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gc_layer_on-6b16a33b7916105a1445dd8ead9a7e76.jpg";